import React from 'react';

import { AISmartCreateSpotlight } from './AISmartCreateSpotlight.tsx';

export type UniversalCreateWithRovoSpotlightProps = {
	onClick: () => void;
	isLoading?: boolean;
	source: string;
	children: React.ReactNode;
};

export const UniversalCreateWithRovoSpotlight = ({
	onClick,
	isLoading,
	source,
	children,
}: UniversalCreateWithRovoSpotlightProps) => {
	return (
		<AISmartCreateSpotlight
			onClick={onClick}
			offset={[0, 16]}
			placement="left-end"
			source={source}
			isLoading={isLoading}
		>
			{children}
		</AISmartCreateSpotlight>
	);
};
